import styled from 'styled-components';

const MapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 78vh;
  margin-bottom: 40px;
  z-index: 10;
`;

export default MapWrapper;
